import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Component, inject, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute, CanActivateFn, Router, RouterModule } from '@angular/router';
import { isSafeInternalRedirectPath, REDIRECT_QUERY_PARAM } from '../redirect-query-param.guard';
import { MatButtonModule } from '@angular/material/button';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { HttpEvent } from '@angular/common/http';
import { HttpHandlerFn } from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

export const AUTHENTICATION_CODE_KEY = "auth_code";

export const MustBeAuthenticatedGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  if (!localStorage.getItem(AUTHENTICATION_CODE_KEY)) {
    const redirect = route.queryParamMap.get(REDIRECT_QUERY_PARAM);
    router.navigate(
      ['/authentication'],
      redirect ? { queryParams: { [REDIRECT_QUERY_PARAM]: redirect } } : undefined,
    );
    return false;
  }
  return true;
}
const API_KEY_HEADER_NAME = "X-API-KEY";

export function HttpRequestInterceptorFunction(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const key = localStorage.getItem(AUTHENTICATION_CODE_KEY);
  if (!key) {
    return next(req);
  }
  const reqWithHeader = req.clone({
    headers: req.headers.set(API_KEY_HEADER_NAME, key),
  });
  return next(reqWithHeader);
}

@Component({
  selector: 'app-authentication-page',
  templateUrl: './authentication-page.component.html',
  styleUrls: ['./authentication-page.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
  ]
})
export class AuthenticationPageComponent implements OnInit {
  public authenticationCodeFormControl = new FormControl('');

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    localStorage.removeItem(AUTHENTICATION_CODE_KEY);
  }

  public submit() {
    if (this.authenticationCodeFormControl.value) {
      localStorage.setItem(AUTHENTICATION_CODE_KEY, this.authenticationCodeFormControl.value);
      const redirect = this.route.snapshot.queryParamMap.get(REDIRECT_QUERY_PARAM);
      const target = redirect && isSafeInternalRedirectPath(redirect) ? redirect : '/';
      this.router.navigateByUrl(target);
    }
  }

}
